// ============================================================================
// Papel de acesso do usuário (lido do JWT — app_metadata.role).
// "full" (sócios) vê tudo; qualquer outro (limited) não vê detalhe/valor de
// contrato nem cria contrato. Default seguro = limited.
// A segurança real é no servidor (view v_onboarding_board + edge functions);
// estes helpers só controlam a UI/navegação.
// ============================================================================

import type { Session } from "@supabase/supabase-js";

export type Role = "full" | "limited";

export function roleFromSession(session: Session | null): Role {
  const r = (session?.user?.app_metadata as { role?: string } | undefined)?.role;
  return r === "full" ? "full" : "limited";
}

export function isFull(session: Session | null): boolean {
  return roleFromSession(session) === "full";
}
